import { CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useStoryView } from "store/main_book_popup/selectors";
import styled from "styled-components";
import StoryWithImages from "./StoryWithAi/StoryView";
import { useCurrentUser } from "store/users/selectors";
import usePopUpAtOnce from "./hooks/usePopUpAtOnce";
import { Cancel } from "@mui/icons-material";
import { useLocation } from 'react-router-dom';

const Wrapper = styled.div`
  position: absolute;
  top:  ${(p) => p.is_student || p.is_teacher ? p.pathname?.includes('ebook') ? "37px" : "0px" : "0px"};
  width: ${(p) => p.width}px;
  height: ${(p) => p.height}px;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 2;
  // box-shadow: 7px -3px 26px 20px rgb(66 66 66),
  //   -4px -3px 26px 15px rgb(95 109 110);
`;




export default function StoryAIPopup({ getRef, onClose, imageConfiguration }) {
  const { storyView, revokeStoryView } = useStoryView();
  const [pages, setPages] = useState({});
  const imageRef = useRef();
  const containerRef = getRef();
  const [style, setStyle] = useState({ height: 0, width: 0 });
  const backBtnRef = useRef();
  const forwardBtnRef = useRef();
  const currentUser = useCurrentUser();
  const {updatePopUpAtOnce} = usePopUpAtOnce();
  const location = useLocation();
  useEffect(() => {
    if (storyView.open) {
      setPages(storyView.pages);
    } else {
      setPages({});
    }
  }, [storyView]);

  useEffect(() => {
    function updateStyle() {
      if (containerRef) {
        const { width, height } = containerRef.getBoundingClientRect();
        setStyle({ height, width });
      }
    }

    updateStyle();
    window.addEventListener("resize", updateStyle);

    return () => {
      window.removeEventListener("resize", updateStyle);
    };
  }, [storyView]);
  useEffect(() => {
    document.addEventListener("keydown", checkKey);
    return () => {
      document.removeEventListener("keydown", () => {});
    };
  }, []);
  const handleClose = () => {
    updatePopUpAtOnce(false);
    revokeStoryView();
    onClose();
  }; 
  function checkKey(e) {
    let isMainBook =
      document.getElementsByClassName("main-book-popup printScreenPageStory")
        .length > 0;
    if (isMainBook) {
      e = e || window.event;
      if (e.keyCode == "37") {
        if (backBtnRef.current && !backBtnRef.current.disabled) {
          backBtnRef.current.click();
        }
      } else if (e.keyCode == "39") {
        if (forwardBtnRef.current && !forwardBtnRef.current.disabled) {
          forwardBtnRef.current.click();
        }
      }
    }
  }


  const content = useMemo(() => {
    if (!pages?.id || !storyView) return '';
    return storyView.type === 'article_level'
      ? pages.articles_text
      : typeof pages.story_content === 'string'
        ? pages.story_content
        : '';
  }, [pages, storyView]);
  
  const title = useMemo(() => {
    if (!pages?.id || !storyView) return '';
  
    return storyView.type === 'article_level'
      ? pages.articles_title
      : typeof pages.story_title === 'string'
        ? pages.story_title
        : '';
  }, [pages, storyView]);
  
  if (!storyView?.open) return null;
  const class_name = storyView.open
    ? storyView.type == "page_translation"
      ? "printScreenPageStory"
      : "main-book-popup printScreenPageStory storyAIPopup"
    : "";
  return (
    <Wrapper
      pathname={location.pathname}
      width={style.width}
      height={style.height - 25}
      className={class_name}
      is_student={currentUser?.role === "student"}
      is_teacher={currentUser?.role === "teacher"}
    >
      {/* <Images src={getPgSrc()} onLoad={handleImageLoad} /> */}
      <Cancel
        onClick={handleClose}
        style={{
          float: 'right',
          fontSize: 20,
          color: 'red',
          background: 'white',
          borderRadius: 20,
          cursor: 'pointer',
          marginBottom: 5,
          zIndex: 20,
          position: 'absolute',
          right: 10,
          top: 10,
        }}
      />
      {/* <div className='printable' style={{height:'100%'}} ref={imageRef}> */}
      {/* <WhiteBox ref={containerRef} className="to_be_print">
        <div
          style={{ maxHeight: "unset" }}
          className="lesson-plan-container to_be_print"
          dangerouslySetInnerHTML={{
            __html: convertToHtml(pages?.story_content || ""),
          }}
        />
      </WhiteBox> */}
      {/* </div> */}
      <StoryWithImages
          imageConfiguration={imageConfiguration}
          ref={imageRef}
          images={pages?.images || []}
          text={content}
          title={title}
          storyInfo={pages || {}}
          is_student={'true'}
        />
    </Wrapper>
  );
}
